module.exports = __webpack_public_path__ + "img/tghd_img_bx1.17278875.png";